<template>
    <v-container class="pa-5" fluid>
        <page-title>Lista raportów</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="4" lg="4">
                            <v-autocomplete
                                v-model="filters.users_ids"
                                :items="users"
                                :filter="customUsersFilter"
                                :loading="usersSearchLoading"
                                :search-input.sync="usersSearch"
                                label="Opearatorzy"
                                class="v-text-field--placeholder-dark"
                                required
                                chips
                                deletable-chips
                                cache-items
                                multiple
                                solo
                                hide-details
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('users_ids')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearch">
                                                Wpisz treść aby odnaleźć <strong>operatora</strong>.
                                            </template>
                                            <template v-else-if="usersSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template #selection="data">
                                    <template v-if="data.item.user">
                                        <template v-if="data.item.user.firstName && data.item.user.lastName">
                                            <v-chip
                                                v-if="data.item.confirm"
                                                color="success"
                                                close
                                                @update:active="removeUser(data.item)"
                                            >
                                                {{ data.item.user.firstName }} {{ data.item.user.lastName }}
                                            </v-chip>
                                            <v-chip
                                                v-else
                                                close
                                                @update:active="removeUser(data.item)"
                                            >
                                                {{ data.item.user.firstName }} {{ data.item.user.lastName }}
                                            </v-chip>
                                        </template>
                                        <template v-else>
                                            <v-chip
                                                v-if="data.item.confirm"
                                                close
                                                color="success"
                                                @update:active="removeUser(data.item)"
                                            >
                                                {{ data.item.user.username }}
                                            </v-chip>
                                            <v-chip
                                                v-else
                                                close
                                                @update:active="removeUser(data.item)"
                                            >
                                                {{ data.item.user.username }}
                                            </v-chip>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="data.item.firstName && data.item.lastName">
                                            <v-chip
                                                close
                                                @update:active="removeUser(data.item)"
                                            >
                                                {{ data.item.firstName }} {{ data.item.lastName }}
                                            </v-chip>
                                        </template>
                                        <template v-else>
                                            <v-chip
                                                close
                                                @update:active="removeUser(data.item)"
                                            >
                                                {{ data.item.username }}
                                            </v-chip>
                                        </template>
                                    </template>
                                </template>

                                <template #item="data">
                                    <template v-if="data.item.user">
                                        <template v-if="data.item.user.firstName && data.item.user.lastName">
                                            {{ data.item.user.firstName }} {{ data.item.user.lastName }}
                                            {{ data.item.user.username }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="data.item.firstName && data.item.lastName">
                                            {{ data.item.firstName }} {{ data.item.lastName }}
                                        </template>
                                        <template v-else>
                                            {{ data.item.username }}
                                        </template>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.productionSite_id"
                                label="Stanowisko"
                                :items="productionSites"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono typu stanowiska"
                                solo
                                clearable
                                hide-details
                                @click:clear="clearFilter('productionSite_id')"
                                @change="changeFilter()"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.productionSiteGroup_id"
                                label="Grupa stanowisk"
                                :items="productionSiteGroups"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono grupy stanowisk"
                                solo
                                clearable
                                hide-details
                                @click:clear="clearFilter('productionSiteGroup_id')"
                                @change="changeFilter()"
                            />
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.finishDateTime__gte"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearables
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('finishDateTime__gte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getForwardDate('finishDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getBackwardDate('finishDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.finishDateTime__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.finishDateTime__lte"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearables
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('finishDateTime__lte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getForwardDate('finishDateTime__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getBackwardDate('finishDateTime__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.finishDateTime__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuTo = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="actionLoading.generateReport"
                    @click="generateReportsSummariesReport"
                >
                    <v-icon
                        v-if="!actionLoading.generateReport"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="reportsSummaries"
                        :loading="reportsSummariesLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="reportsSummariesData"
                        @pagination="updatePagination"
                    >
                        <template #item.user="{item}">
                            {{ item.firstName }} {{ item.lastName }}
                        </template>
                        <template #item.efficiency="{item}">
                            <template v-if="item.efficiency">
                                <template>
                                    {{ item.efficiency }}
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import customFilters from '@/mixins/customFilters'
import pagination from '@/mixins/dataTablePagination'
import parse from '@/mixins/parse.js'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

let searchTimer

export default {
    name: 'ReportsSummaries',
    components: {
        PageTitle
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        filters,
        pagination,
        parse,
        customFilters
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('reportsAndAnalysis/reports/clearReportsSummariesFilters')
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            menuFrom: false,
            menuTo: false,
            typeChanged: false,
            usersSearch: null,
            usersSearchLoading: false,
            actionLoading: {
                generateReport: false
            },
            users: [],
            headers: [
                {
                    text: 'Pracownik',
                    value: 'user',
                    sortable: false,
                    align: 'start',
                },
                {
                    text: 'Wydajność',
                    value: 'efficiency',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Suma czasu',
                    value: 'timeWorkedAtMinutes',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Suma nakładu',
                    value: 'doneAmount',
                    sortable: false,
                    align: 'center',
                },
            ],
            user: {}
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        reportsSummaries() {
            return this.$store.state.reportsAndAnalysis.reports.reportsSummaries.reportsSummaries
        },
        reportsSummariesLoading() {
            return this.$store.state.reportsAndAnalysis.reports.reportsSummaries.reportsSummariesLoading
        },
        productionSites() {
            return this.$store.state.configurations.productionSites.productionSites
        },
        productionSiteGroups() {
            return this.$store.state.configurations.productionSites.productionSiteGroups
        },
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.reports.reportsSummaries.reportsSummariesFilters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (item == 'finishDateTime__gte') {
                        filters[item] += 'T00:00:00Z'
                    }

                    if (item == 'finishDateTime__lte') {
                        filters[item] += 'T23:59:59Z'
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        }
    },
    mounted() {
        Promise.all([
            this.getUser(),
            this.getReportsSummaries(),
            this.getProductionSites(),
            this.getProductionSitesGroups()
        ])
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.users = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        getUser() {
            this.$store.dispatch('administration/getUser', this.userId )
                .then(response => {
                    this.user = response.data
                })
        },
        generateReportsSummariesReport() {
            this.actionLoading.generateReport = true
            this.$store.dispatch('reportsAndAnalysis/reports/generateReportsSummariesReport', {
                query: this.filterQuery,
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReport = false
                })
        },
        removeUser(user) {
            this.filters.users_ids.splice(this.filters.users_ids.indexOf(user.id), 1)
            this.changeFilter()
        },
        getBackwardDate(finishDateTime) {
            if (Date.parse(this.filters[finishDateTime])) {
                this.filters[finishDateTime] = this.getDayBackward(this.filters[finishDateTime])
                this.changeFilter()
            }
        },
        getForwardDate(finishDateTime) {
            if (Date.parse(this.filters[finishDateTime])) {
                this.filters[finishDateTime] = this.getDayForward(this.filters[finishDateTime])
                this.changeFilter()
            }
        },
        getReportsSummaries() {
            this.$store.dispatch('reportsAndAnalysis/reports/getReportsSummaries', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getProductionSites() {
            this.$store.dispatch('configurations/getProductionSites')
                .catch(error => {
                    errorHandler(error)
                })
        },
        getProductionSitesGroups() {
            this.$store.dispatch('configurations/getProductionSitesGroups')
                .catch(error => {
                    errorHandler(error)
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisReportsReports' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('reportsAndAnalysis/reports/setReportsSummariesFilters', this.filters)
            this.resetPagination()
            this.getReportsSummaries()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getReportsSummaries()
            }
            this.clearPaginationPending()
        }
    }
}

</script>